import Lara from '@primeng/themes/lara';
import { definePreset } from '@primeuix/themes';

// Lara preset with purple primary palette + SLATE surface (dark blue-grey) — restores the
// "lara-dark-purple" from the v17 port that used a slate scale in dark mode.
// PrimeNG 21 Lara default uses ZINC (neutral grey / near black) in dark, which produces a
// "flat black" look.
// F2.5 commit 2.5.15 (iter7): override `surface` in dark mode -> slate scale for blue-navy tone.
// F2.5 commit 2.5.8: override primary to purple.
// Applied via providePrimeNG({ theme: { preset: PurpleLara } }) in each app.config.ts.
export const PurpleLara = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#faf5ff',
      100: '#f3e8ff',
      200: '#e9d5ff',
      300: '#d8b4fe',
      400: '#c084fc',
      500: '#a855f7',
      600: '#9333ea',
      700: '#7e22ce',
      800: '#6b21a8',
      900: '#581c87',
      950: '#3b0764',
    },
    colorScheme: {
      dark: {
        surface: {
          0: '#ffffff',
          50: '#f8fafc',
          100: '#f1f5f9',
          200: '#e2e8f0',
          300: '#cbd5e1',
          400: '#94a3b8',
          500: '#64748b',
          600: '#475569',
          700: '#334155',
          800: '#1e293b',
          900: '#0f172a',
          950: '#020617',
        },
      },
    },
  },
  components: {
    // Lara default button gap is 0.5rem — bump to 0.75rem for clearer separation
    // between icon and label (decisión usuario 2026-05-22 durante sweep elements-content
    // del refactor eslint-rules-cleanup-finish). Aplica a todos los <button pButton>
    // y <p-button> de admin/web/www. La key correcta es `root.gap` según el type
    // ButtonDesignTokens de @primeuix/themes.
    button: {
      root: {
        gap: '0.75rem',
      },
    },
  },
});
